import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle, X } from 'react-feather';

interface ErrorMessageProps {
  message: string;
  className?: string;
  onClose?: () => void;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ 
  message,
  className = '',
  onClose
}) => {
  const { t } = useTranslation();
  
  return (
    <div className={`
      flex items-center gap-2
      p-4 rounded-lg
      bg-red-50 text-red-700
      border border-red-200
      ${className}
    `}>
      <AlertTriangle className="h-5 w-5 flex-shrink-0" />
      <p className="text-sm flex-1">{message}</p>
      {onClose && (
        <button 
          onClick={onClose}
          className="text-red-500 hover:text-red-700 transition-colors"
          aria-label="Close"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;